import { AutoCalcPLMap } from "../../constants";

export const autoCalcPL = ((tableValue:{[key: string]: number}, key: string) => {
        // 更新項目に紐づく自動計算項目が存在している場合は、個別の計算処理を呼び出す
        if(AutoCalcPLMap["GP"].includes(key)){
            // 売上総利益
            autoCalcGrossProfit(tableValue)
        }else if(AutoCalcPLMap["OP"].includes(key)){
            // 営業利益
            autoCalcOperatingProfit(tableValue)
        }else if(AutoCalcPLMap["TnOI"].includes(key)){
            // 営業外収益
            autoCalcNonOperatingIncome(tableValue)
        }else if(AutoCalcPLMap["TnOE"].includes(key)){
            // 営業外費用
            autoCalcNonOperatingExpenses(tableValue)
        }else if(AutoCalcPLMap["OrP"].includes(key)){
            // 経常利益
            autoCalcOrdinaryProfit(tableValue)
        }else if(AutoCalcPLMap["PP"].includes(key)){
            // 税引前当期純利益
            autoCalcPretaxProfit(tableValue)
        }else if(AutoCalcPLMap["NI"].includes(key)){
            // 当期純利益
            autoCalcNetIncome(tableValue)
        }
})

// 売上総利益（売上高 - 売上原価）
const autoCalcGrossProfit = ((tableValue:{[key: string]: number}) => {
    tableValue["GP"] = inputLimitControl(tableValue["S"] - tableValue["CoS"])
    autoCalcOperatingProfit(tableValue)
})
// 営業利益（売上総利益 - 販売費及び一般管理費）
const autoCalcOperatingProfit = ((tableValue:{[key: string]: number}) => {
    tableValue["OP"] = inputLimitControl(tableValue["GP"] - tableValue["SGaAE"])
    autoCalcOrdinaryProfit(tableValue)
})
// 営業外収益（受取利息・配当金 + その他営業外収益）
const autoCalcNonOperatingIncome = ((tableValue:{[key: string]: number}) => {
    tableValue["TnOI"] = inputLimitControl(tableValue["TnOI_IaDA"] + tableValue["TnOI_OnOI"])
    autoCalcOrdinaryProfit(tableValue)
})
// 営業外費用（支払利息・手形売却損 + その他営業外費用）
const autoCalcNonOperatingExpenses= ((tableValue:{[key: string]: number}) => {
    tableValue["TnOE"] = inputLimitControl(tableValue["TnOE_IaDA"] + tableValue["TnOE_OnOI"])
    autoCalcOrdinaryProfit(tableValue)
})
// 経常利益（営業利益 + 営業外収益 - 営業外費用）
const autoCalcOrdinaryProfit = ((tableValue:{[key: string]: number}) => {
    tableValue["OrP"] = inputLimitControl(tableValue["OP"] + tableValue["TnOI"] - tableValue["TnOE"])
    autoCalcPretaxProfit(tableValue)
})
// 税引前当期純利益（経常利益 + 特別利益 - 特別損失）
const autoCalcPretaxProfit = ((tableValue:{[key: string]: number}) => {
    tableValue["PP"] = inputLimitControl(tableValue["OrP"] + tableValue["SP"] - tableValue["EL"])
    autoCalcNetIncome(tableValue)
})
// 当期純利益（税引前当期純利益 - 法人税等充当額）
const autoCalcNetIncome = ((tableValue:{[key: string]: number}) => {
    tableValue["NI"] = inputLimitControl(tableValue["PP"] - tableValue["APfCT"])
})

const inputLimitControl = ((v: number) => {
    if(v > 99999999){
        v = 99999999
    }else if(v < -99999999){
        v = -99999999
    }else{
        v = v
    }
    return v
})
